// extracted by mini-css-extract-plugin
export default {"section":"table_section__J1pos","table":"table_table__Y-yxT","table_header":"table_table_header__5rNcx","table_body":"table_table_body__Ju3A-"};